export const TIME_CONFIG = {
  M: {
    1: 60000,
    2: 120000,
    5: 300000,
    10: 600000,
    15: 900000,
    30: 1800000,
    60: 3600000,
  },
  S: {
    1: 1000,
    2: 2000,
    3: 3000,
    4: 4000,
    5: 5000,
  },
} as const;

export const PROFILE_STATUS = {
  "PRFL-CMTD": 1000000,
  "PRFL-PNDG": 1000001,
};
export const EMPLOYEE_STATUS = {
  ACTIVE: 1000000,
  "Ex-employee": 1000001,
};

export const FORMATE = {
  DATE: "DD MMM YYYY",
  DATE_TIME: "DD MMM YYYY, hh:mm A",
};

export const DOCUMENT_STATUS_LIST = ["approved", "declined"];
export const LOCALSTORAGE_KEY = "employeeTableColumnSizingV1";
export const PINNED_LOCALSTORAGE_KEY = "employeeTablePinnedColumnsV1";
export const EMPTY_VALUE_FILTER_OPERATOR = [
  "is_empty",
  "is_not_empty",
  "today",
  "yesterday",
  "last_week",
  "last_month",
  "last_year",
  "this_week",
  "this_month",
  "this_year",
];

export const PAGINATION_CONFIG = { initialPage: 1, initialPerPage: 25, perPageOptions: [10, 25, 50, 100] };

export const PERMISSIONS = {
  SETTING: {
    "View Org Profile": "View Org Profile",
    "Edit Org Profile": "Edit Org Profile",
    "View Documents": "View Documents",
    "Create Documents": "Create Documents",
    "Edit Documents": "Edit Documents",
    "Create Signatory": "Create Signatory",
    "Edit Signatory": "Edit Signatory",
    "View Signatory": "View Signatory",
    "Delete Signatory": "Delete Signatory",
    "Create Letterhead": "Create Letterhead",
    "Edit Letterhead": "Edit Letterhead",
    "View Letterhead": "View Letterhead",
  },
  EMPLOYEE: {
    "Create Employees": "Create Employees",
    "Edit Employees": "Edit Employees",
    "View Employees": "View Employees",
    "Import Employees": "Import Employees",
    "Export Employees": "Export Employees",
    "Delete Employees": "Delete Employees",
    "Re-invite Employees": "Re-invite Employees",
    "View Reporting Employee": "View Reporting Employee",
    "View Own Employee": "View Own Employee",
    "Web Access": "Web Access",
    "View Payment History": "View Payment History",
  },
  ROLES: {
    "View Roles": "View Roles",
    "Create Roles": "Create Roles",
    "Edit Roles": "Edit Roles",
    "Delete Roles": "Delete Roles",
    "Manage Permission": "Manage Permission",
  },
  PAYMENT: {
    "LP Share": "LP Share",
    "Download Receipt": "Download Receipt",
    "Export Payments": "Export Payments",
    // "Outgoing Payments": "Outgoing Payments",
    "Incomming Payments": "Incomming Payments",
    "View Payment History": "View Payment History",
  },
} as const;

export const SETTINGS_NAVBAR_LINKS = [
  {
    name: "Organization profile",
    icon: "/icons/organization.svg",
    description: "Manage your organization profile here",
    path: "/home/settings/organization-profile",
    perms: [
      PERMISSIONS.SETTING["View Documents"],
      PERMISSIONS.SETTING["View Org Profile"],
      PERMISSIONS.SETTING["View Signatory"],
      PERMISSIONS.SETTING["View Letterhead"],
    ],
  },
  // {
  //   name: "Billing",
  //   icon: "/icons/billing.svg",
  //   description: "Manage your billing information here",
  //   path: "/home/setting/billing",
  // },
  {
    name: "Roles",
    icon: "/icons/roles-and-permission.svg",
    description: "Manage your user roles and permission here",
    path: "/home/settings/roles",
    perms: [PERMISSIONS.ROLES["View Roles"]],
  },
];
